export default __webpack_public_path__ + "static/media/IDAHOBIT_SPD.5f7bd45d.mp4";